import React from 'react';
import { useDrag } from 'react-dnd';
import PropTypes from 'prop-types';
import DraggableIcon from '../../../../DraggableIcon';
import { useFilePath } from '../../../../../hooks/useFilePath';
import MapIconWrapper from '../../../../MapIcon';

const DnDAsset = ({ asset, didDrop, disabled }) => {
  const { buildIconPath } = useFilePath();
  const [{ isDragging }, drag] = useDrag({
    type: 'BOX',
    item: { name: 'AssetSideListBucket', asset },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) didDrop(asset.id, dropResult);
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: !disabled,
  });

  if (isDragging) return <div ref={drag} data-testid="drag-component" />;

  return (
    <DraggableIcon
      setRef={drag}
      title={asset.name}
      Icon={
        <MapIconWrapper
          id={asset.id}
          src={buildIconPath(asset.icon)}
          status={asset.status.toLowerCase()}
          cursorStyle="grab"
        />
      }
    />
  );
};

DnDAsset.propTypes = {
  asset: PropTypes.object.isRequired,
  didDrop: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DnDAsset;
